import classNames from 'classnames';
import IconButton from 'components/common/IconButton';
import { PropertyWizardContext } from 'context/Context';
import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const FooterWizard = () => {
  const { step, setStep, setAction, yupSubmitRef, status } = useContext(
    PropertyWizardContext
  );

  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);
  const [nextLoading, setNextLoading] = useState(false);

  const handleExitWithoutSave = () => {
    navigate('/propiedades');
  };

  const handleNext = async () => {
    setNextLoading(true);
    setAction('next');
    try {
      if (step === 3 || step === 4 || step === 5) {
        await new Promise(resolve => setTimeout(resolve, 1000));
      } else {
        await new Promise(resolve => setTimeout(resolve, 500));
      }
      yupSubmitRef.current.click();
    } catch (error) {
      console.error('Error al guardar los datos', error);
    } finally {
      setNextLoading(false);
    }
  };

  const handleExit = async () => {
    setSaving(true);
    setAction('exit');
    try {
      await new Promise(resolve => setTimeout(resolve, 500));
      yupSubmitRef.current.click();
    } catch (error) {
      console.error('Error al guardar y salir', error);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        gap: '1rem',
        flexWrap: 'wrap',
        justifyContent: 'center'
      }}
    >
      {step > 1 && (
        <IconButton
          className="btnFooter"
          variant="light"
          icon="chevron-left"
          onClick={() => {
            if (step > 1) setStep(step - 1);
          }}
        >
          Atrás
        </IconButton>
      )}

      <IconButton
        variant="light"
        className="btnFooter"
        icon="xmark"
        onClick={handleExitWithoutSave}
      >
        Salir sin guardar
      </IconButton>

      <IconButton
        variant="outline-primary"
        className={classNames({
          'd-none': step === 1,
          btnFooter: 'btnFooter'
        })}
        icon="floppy-disk"
        onClick={handleExit}
        disabled={saving}
      >
        {saving ? 'Cargando...' : 'Guardar y salir'}
      </IconButton>

      {(step !== 5 || status !== 'published') && (
        <IconButton
          className="btnFooter"
          variant="primary"
          icon="floppy-disk"
          onClick={() => {
            if (!nextLoading) {
              handleNext();
            }
          }}
          disabled={nextLoading}
        >
          {nextLoading
            ? 'Cargando...'
            : step !== 5
            ? 'Guardar y seguir'
            : status !== 'published'
            ? 'Publicar aviso'
            : null}
        </IconButton>
      )}
    </div>
  );
};
